import { Navigate, Outlet, useParams } from 'react-router-dom'
import { routes } from '../../shared/constants/routes'

export const LivingComplexPage = () => {
  const { livingComplexId } = useParams<{ livingComplexId: string }>()

  if (!livingComplexId) {
    return <Navigate to={routes.error('404.1')} replace />
  }

  return <Outlet />
}
